import React from 'react';
import Box from '@mui/material/Box';
import { CustomLoadingButton } from './CustomButtons';
import theme from 'theme';

export const PrimaryActionVariants = {
  error: 'error', success: 'success', warning: 'warning', info: 'info',
};

export function ActionButtons({
  loading, primaryAction, secondaryAction, onPrimaryClick, onSecondaryClick,
  primaryActionVariant, secondaryActionVariant, primaryFirst, primaryType,
  secondaryType,disabled, ...props
}) {
  return (
    <Box display='flex' alignItems="center" width="fit-content" padding={theme.spacing(0,3)} {...props}>
      {primaryFirst && (
        <>
          <CustomLoadingButton
            fullWidth
            loading={loading}
            size="medium"
            type={primaryType}
            onClick={onPrimaryClick}
            variant='contained'
            color={PrimaryActionVariants[primaryActionVariant] || 'primary'}
            disabled={disabled}
          >
            {primaryAction}
          </CustomLoadingButton>
          &nbsp;&nbsp;
        </>
      )}
      <CustomLoadingButton
        fullWidth
        size="medium"
        onClick={onSecondaryClick}
        type={secondaryType}
        color={PrimaryActionVariants[secondaryActionVariant] || 'primary'}
        variant='outlined'
        disabled={disabled}
      >
        {secondaryAction}
      </CustomLoadingButton>
      {!primaryFirst && (
        <>
          &nbsp;&nbsp;
          <CustomLoadingButton
            fullWidth
            loading={loading}
            size="medium"
            onClick={onPrimaryClick}
            variant='contained'
            color={PrimaryActionVariants[primaryActionVariant] || 'primary'}
            disabled={disabled}
          >
            {primaryAction}
          </CustomLoadingButton>
        </>
      )}
    </Box>
  );
}

export default ActionButtons;